import React, { Component } from 'react';
import PageHeader from '../components/PageHeader';
import __ from '../utils/translator';
import GlossaryStoreActions from '../flux/GlossaryStoreActions';
import GlossaryTermStore from '../flux/GlossaryTermStore';
import TermList from '../components/TermList'
import thronThumbnail from '../utils/thronThumbnail';
import PageTitle from '../components/PageTitle';
import Header from '../components/organisms/Header';
import themeResponsiveProperty from "../components/responsive/themeResponsiveProperty";
import { withTheme } from "styled-components";

class GlossaryTerm extends Component {
  state = {
    termDidLoad: false,
    terms: [],
    termName: '',
  };

  subscriptions = [];

  componentDidMount() {
    GlossaryStoreActions.getTermById(this.props.match.params.id);

    this.subscriptions.push(GlossaryTermStore.addListener(() => {
      this.setState({
        termDidLoad: true,
        terms : [GlossaryTermStore.getState()],
        termName: GlossaryTermStore.getState().name
      });
    }));
  };

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header actions={themeResponsiveProperty(['back', 'close-fullscreen-modal'], undefined)(this.props)} />

        {this.state.termDidLoad && (
          <PageTitle withTracking title={`Glossary / ${this.state.termName}`} />
        )}

        <PageHeader
          crumbs={[__('Home'), __('Glossary')]}
          title={this.state.termName}
          cover={thronThumbnail('6c903584-92ca-41d2-912e-c5e68ce4810b')} />

        <TermList
          terms={this.state.terms} />
      </div>
    );
  }
}

export default withTheme(GlossaryTerm);

